(function () {
  // Formatage de prix standard Shopify, respecte shop.money_format (ex: "${{amount}}", "{{amount}} $")
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultOption(opt, def) { return typeof opt === 'undefined' ? def : opt; }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initVolumeOffer(root) {
    if (root.dataset.volumeOfferInit) return;
    root.dataset.volumeOfferInit = 'true';

    var tiers = root.querySelectorAll('[data-volume-offer-tier]');
    var submitBtn = root.querySelector('[data-volume-offer-submit]');
    var submitText = root.querySelector('[data-volume-offer-submit-text]');
    var errorEl = root.querySelector('[data-volume-offer-error]');
    var defaultSubmitText = submitText ? submitText.textContent : 'Add to cart';
    var gifts = root.querySelectorAll('[data-gift]');
    var colorMapEl = root.querySelector('[data-color-variant-map]');
    var colorMap = colorMapEl ? JSON.parse(colorMapEl.textContent) : {};
    var giftCardVariantId = root.dataset.giftCardVariantId;
    var giftCardMinQty = parseInt(root.dataset.giftCardMinQty, 10) || 2;
    var guideVariantId = root.dataset.guideVariantId;
    var guideMinQty = parseInt(root.dataset.guideMinQty, 10) || 1;
    var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
    var priceSuffix = root.dataset.priceSuffix || '';
    var savingsTemplate = root.dataset.savingsTemplate || 'Save [percent]%';

    var loadingText = root.dataset.loadingText || 'Adding...';
    var errorMissingColor = root.dataset.errorMissingColor || 'Please select an option for each item.';
    var errorGeneric = root.dataset.errorGeneric || 'Something went wrong. Please try again.';

    // Composant panier natif de Dawn (drawer ou notification, selon le réglage du thème)
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    function getSelectedItems() {
      var selectedTier = root.querySelector('.volume-offer__tier.is-selected');
      if (!selectedTier) return null;

      var selects = selectedTier.querySelectorAll('[data-color-select]');
      var items = [];
      var missing = false;

      if (selects.length) {
        selects.forEach(function (select) {
          var entry = colorMap[select.value];
          if (!entry) {
            missing = true;
            return;
          }
          items.push({ id: entry.id, quantity: 1 });
        });

        if (missing) return null;
      } else {
        // Produit à variante unique : pas de sélecteur de couleur,
        // on ajoute directement la variante par défaut pour la quantité du palier.
        var unitQty = parseInt(selectedTier.dataset.qty, 10) || 1;
        items.push({ id: root.dataset.variantId, quantity: unitQty });
      }

      var qty = getSelectedQty();
      if (guideVariantId && qty >= guideMinQty) {
        items.push({ id: guideVariantId, quantity: 1 });
      }
      if (giftCardVariantId && qty >= giftCardMinQty) {
        items.push({ id: giftCardVariantId, quantity: 1 });
      }

      return items;
    }

    function updateGifts(qty) {
      gifts.forEach(function (gift) {
        var min = parseInt(gift.dataset.giftMinQty, 10) || 1;
        gift.classList.toggle('is-active', qty >= min);
      });
    }

    function getSelectedQty() {
      var checked = root.querySelector('.volume-offer__radio:checked');
      return checked ? parseInt(checked.value, 10) : 1;
    }

    // Recalcule et affiche le prix d'un palier à partir des vraies variantes sélectionnées
    function updateTierPrice(tierEl) {
      var priceBlock = tierEl.querySelector('[data-tier-price]');
      if (!priceBlock) return;

      var discountPercent = parseFloat(priceBlock.dataset.discountPercent) || 0;
      var qty = parseInt(priceBlock.dataset.qty, 10) || 1;

      var selects = tierEl.querySelectorAll('[data-color-select]');
      var baseTotalCents = 0;
      var compareTotalCents = 0;
      var missing = false;

      if (selects.length) {
        selects.forEach(function (select) {
          var entry = colorMap[select.value];
          if (!entry) {
            missing = true;
            return;
          }
          baseTotalCents += entry.price;
          compareTotalCents += entry.comparePrice || entry.price;
        });

        if (missing) return;
      } else {
        // Produit à variante unique : prix calculé directement à partir
        // de la variante par défaut, multiplié par la quantité du palier.
        var defaultEntry = colorMap[Object.keys(colorMap)[0]];
        if (!defaultEntry) return;
        baseTotalCents = defaultEntry.price * qty;
        compareTotalCents = (defaultEntry.comparePrice || defaultEntry.price) * qty;
      }

      var discountCents = Math.round((baseTotalCents * discountPercent) / 100);
      var displayTotalCents = baseTotalCents - discountCents;

      var displayPerUnitCents = qty > 1 ? Math.round(displayTotalCents / qty) : displayTotalCents;
      var comparePerUnitCents = qty > 1 ? Math.round(compareTotalCents / qty) : compareTotalCents;

      var priceNowEl = priceBlock.querySelector('[data-price-now]');
      var priceCompareEl = priceBlock.querySelector('[data-price-compare]');

      if (priceNowEl) {
        var suffixHtml = qty > 1 && priceSuffix
          ? '<span class="volume-offer__price-suffix">' + priceSuffix + '</span>'
          : '';
        priceNowEl.innerHTML = formatMoney(displayPerUnitCents, moneyFormat) + suffixHtml;
      }

      if (priceCompareEl) {
        if (compareTotalCents > displayTotalCents) {
          priceCompareEl.hidden = false;
          priceCompareEl.innerHTML = formatMoney(comparePerUnitCents, moneyFormat);
        } else {
          priceCompareEl.hidden = true;
        }
      }

      var savingsEl = tierEl.querySelector('[data-savings-text]');
      if (savingsEl) {
        if (compareTotalCents > displayTotalCents) {
          var savingsPercent = Math.round(((compareTotalCents - displayTotalCents) / compareTotalCents) * 100);
          savingsEl.textContent = savingsTemplate.replace('[percent]', savingsPercent);
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    }

    function updateAllTierPrices() {
      tiers.forEach(function (tier) { updateTierPrice(tier); });
    }

    tiers.forEach(function (tier) {
      var radio = tier.querySelector('.volume-offer__radio');
      tier.addEventListener('click', function (e) {
        if (e.target.closest('[data-color-select]')) return;

        tiers.forEach(function (t) { t.classList.remove('is-selected'); });
        tier.classList.add('is-selected');
        radio.checked = true;
        updateGifts(getSelectedQty());
      });

      var colorSelects = tier.querySelectorAll('[data-color-select]');
      colorSelects.forEach(function (select) {
        select.addEventListener('change', function () {
          updateTierPrice(tier);
        });
      });
    });

    updateGifts(getSelectedQty());
    updateAllTierPrices();

    function setLoading(isLoading) {
      submitBtn.disabled = isLoading;
      if (submitText) {
        submitText.textContent = isLoading ? loadingText : defaultSubmitText;
      }
    }

    // Version défensive de cart.renderContents() : au lieu de planter dès qu'une
    // section attendue par Dawn est absente de la réponse ou de la page, on
    // ignore simplement cette section-là et on continue avec les autres.
    function renderCartSectionsSafely(parsedState) {
      if (!cart || typeof cart.getSectionsToRender !== 'function') return false;

      var updatedAny = false;

      cart.getSectionsToRender().forEach(function (section) {
        // Le <cart-drawer> de Dawn retourne des sections avec seulement .id
        // (pas .section), d'où le fallback : sans lui, la clé de lookup est
        // undefined et rien ne s'injecte -> drawer qui s'ouvre vide.
        var sectionName = section.section || section.id;
        var html = parsedState.sections && parsedState.sections[sectionName];
        if (!html) return;

        var targetEl = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!targetEl) return;

        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceEl = section.selector ? doc.querySelector(section.selector) : doc.getElementById(section.id);
        if (sourceEl) {
          targetEl.innerHTML = sourceEl.innerHTML;
          updatedAny = true;
        }
      });

      return updatedAny;
    }

    function addOfferToCart() {
      var items = getSelectedItems();
      errorEl.hidden = true;

      if (!items) {
        errorEl.textContent = errorMissingColor;
        errorEl.hidden = false;
        return;
      }

      setLoading(true);

      var body = { items: items };

      // Demande à Shopify de renvoyer le HTML déjà rendu des sections du panier
      // natif de Dawn (cart-drawer / cart-notification), en un seul aller-retour.
      // "section" (et non "id") est le nom attendu par Shopify dans la requête ;
      // "id" sert seulement à savoir où injecter le HTML reçu dans le DOM.
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.section || s.id; });
        body.sections_url = window.location.pathname;
      }

      // routes.cart_add_url ne contient PAS le suffixe .js -> sans lui, Shopify
      // traite l'appel comme une soumission de formulaire classique (redirection
      // HTML) au lieu d'une requête AJAX (réponse JSON).
      var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
      if (addUrl.indexOf('.js') === -1) addUrl += '.js';

      fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (err) { throw err; });
          return res.json();
        })
        .then(function (response) {
          setLoading(false);

          if (cart) {
            // Dawn cache le contenu du panier tant que <cart-drawer> porte la classe
            // is-empty (posée au chargement quand le panier était vide). Le flow natif
            // la retire avant d'ouvrir ; notre renderer maison doit faire pareil, sinon
            // le drawer s'ouvre sur "Votre panier est vide" malgré l'item ajouté.
            cart.classList.remove('is-empty');
            renderCartSectionsSafely(response);
            if (typeof cart.open === 'function') {
              cart.open();
            } else {
              window.location = (window.routes && window.routes.cart_url) || '/cart';
            }
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        })
        .catch(function (err) {
          errorEl.textContent = (err && err.message) || errorGeneric;
          errorEl.hidden = false;
          setLoading(false);
        });
    }

    submitBtn.addEventListener('click', addOfferToCart);
        // Expose pour le sticky add to cart : appel direct de la logique reelle
    // (validation, fetch, cadeaux, rendu + ouverture du cart-drawer de Dawn)
    // sans passer par une simulation de clic sur submitBtn, peu fiable
    // (timing, etat disabled, ordre de binding).
    window.__submitVolumeOffer = addOfferToCart;

    // Masque le formulaire natif de Dawn sur cette page -> notre bouton devient
    // le seul point d'ajout au panier pour ce produit.
    var formSelector = root.dataset.productFormSelector;
    var nativeForms = formSelector ? document.querySelectorAll(formSelector) : [];

    nativeForms.forEach(function (nativeForm) {
      nativeForm.closest('product-form').style.display = 'none';
    });
  }

  document.querySelectorAll('[data-volume-offer]').forEach(initVolumeOffer);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-volume-offer]').forEach(initVolumeOffer);
  });
})();
